import styled from 'styled-components';
import {dFlexColumnCenter, dFlexCenter, alignEnd, justifyEnd} from '../../../../../../../globalVariables/GlobalFlex';
import zIndex from '../../../../../../../globalVariables/zIndex';
import {summeryText} from '../../../../genericPieChart/GenericPieChart.css';
import {getFontSize, getFontWeight, getPrimitive, getSpacing} from '@tickchak/react-share/app';
import {mobileMedia} from '../../../../../../../globalVariables/GlobalVariables';

export const chartWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 70px;
    ${dFlexCenter}
    ${alignEnd}
    margin-bottom: ${getSpacing('spaceSm')};
    ${summeryText}{
        z-index: ${zIndex.baseRaised};    
        ${justifyEnd};
    }
`;

export const percentage = styled.div`
    font-size: ${getFontSize('h3')};
    font-weight: ${getFontWeight('semibold')};
    line-height: 1.2;
    text-align: center;
`;

export const percentageLabel = styled.div`
    font-size: ${getFontSize('overline')};
    font-weight: ${getFontWeight('bold')};
    line-height: 1;
    text-align: center;
`;

export const statsContainer = styled.div`
    ${dFlexColumnCenter}
    gap: ${getSpacing('spaceXs')};
    width: 100%;
`;

export const statItem = styled.div`
    font-size: ${getFontSize('caption')};
    text-align: center;
    width: 100%;
    line-height: 1.3;
`;

export const activeEventsBar = styled.div`
    ${dFlexCenter}
    width: 100%;
    max-width: 120px;
    height: 25px;
    background: ${getPrimitive('grays.gray100')};
    border-radius: ${getSpacing('spaceLg')};
    padding: 0 ${getSpacing('spaceSm')};
    gap: ${getSpacing('spaceXs')};
    &::after {
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${getPrimitive('greens.green400')};
        flex-shrink: 0;
    }
`;

export const activeEventsText = styled.span`
    font-size: ${getFontSize('caption')};
`;

export const activeEventsCount = styled.span`
    font-size: ${getFontSize('caption')};
    font-weight: ${getFontWeight('bold')};
`;
export const summarySection = styled.div`
    width: 168px;
    padding-top: var(--space-3xl);
    ${mobileMedia}{
        width: 100%;
        padding: ${getSpacing('spaceXl')} 0;
    }
`;
